import locale from '../locale';
var CONST = {
  MONTH: locale.lng('DatePicker.monthText'),
  DAYS: locale.lng('DatePicker.daysText')
};
var PANEL_LIST = {
  dateShow: false,
  monthShow: false,
  yearShow: false
};
var END_PANEL_LIST = {
  enddateShow: false,
  endmonthShow: false,
  endyearShow: false
};
export default CONST;
export { PANEL_LIST, END_PANEL_LIST };